import { getSessionForAccessInfo } from "./GraphMain";
import { accessInfoType } from "../utils/classInfos";
import { getElementAppInfo } from "./graphAppInfoElementFunctions";
import { getCalculationInfoForElement } from "./graphAppInfoElementFunctions";

export async function getCalculationData(
  accessInfo: accessInfoType,
  calculationId: string
) {
  console.count("INFO getCalculationData");
  const sessionInfo  = await getSessionForAccessInfo(accessInfo);
  // check the info
  if (!sessionInfo || !sessionInfo.sessionId) return null;
  const {client, sessionId, fileUrl} = sessionInfo;

  // get the view info
  console.time("graphCalculationFunctions getCalculationInfoForElement")
  let calculationInfo = await getCalculationInfoForElement(accessInfo, calculationId, "calculation", sessionId, fileUrl, client);
  console.timeEnd("graphCalculationFunctions getCalculationInfoForElement")
  if (!calculationInfo) { return null }
  let elementName = calculationInfo.caption;

  // get the calculation values
  let data = { };

  // helper tables
  const helperTables = undefined; //getHelperTables(tableTables?.value);

  // get the app info
  let appInfo = await getElementAppInfo(accessInfo, calculationId, "calculation", sessionId, fileUrl, client, helperTables);
  

  return { 
    calculationId,
    appInfo,
    elementName,
    accessInfo,
    data,
    calculationInfo
  };
}

